import { render, staticRenderFns } from "./MTourBodyLine.vue?vue&type=template&id=1f37b5d4&scoped=true"
import script from "./MTourBodyLine.vue?vue&type=script&lang=js"
export * from "./MTourBodyLine.vue?vue&type=script&lang=js"
import style0 from "./MTourBodyLine.vue?vue&type=style&index=0&id=1f37b5d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f37b5d4",
  null
  
)

export default component.exports